import { IngressRequest } from '@dispatch/shared/types';
import { dispatchClient } from '../clients';

const INGRESS_SERVICE_BASE_URL = 'dispatch/tasks';

export async function ingressTask(data: IngressRequest) {
  try {
    const response = await dispatchClient.post(INGRESS_SERVICE_BASE_URL, data);

    return {
      success: response.status === 200,
    };
  } catch (error) {
    return {
      success: false,
      message: error,
    };
  }
}
